import {Dispatchable} from "../../stem-core/src/base/Dispatcher";
import {getQueryParam} from "../UtilsLib";


class SocialAuthService extends Dispatchable {
    constructor() {
        super();
        this.referralMerchantId = getQueryParam("clientId");
    }

    setReferralMerchantId(referralMerchantId) {
        this.referralMerchantId = referralMerchantId;
        this.dispatch("update");
    }
}

export const socialAuthService = new SocialAuthService();
